export default "__VITE_ASSET__CY73K9Er__"